import React, { useEffect, useState } from "react";

const Logout = () => {
  const [hover, setHover] = useState(false);

  return (
    <svg
      className="w-6 h-6"
      viewBox="0 0 22 23"
      xmlns="http://www.w3.org/2000/svg"
      fill={hover ? "#BA004F" : "#C1A4A4"}
      onMouseEnter={() => setHover(true)}
      onMouseLeave={() => setHover(false)}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.1151 -0.000305176H10.8855C10.2527 -0.000305176 9.7397 0.512506 9.7397 1.14555V7.85294C9.7397 8.48558 10.2527 8.99842 10.8855 8.99842H11.1151C11.7478 8.99842 12.2606 8.48558 12.2606 7.85294V1.14555C12.2606 0.512506 11.7478 -0.000305176 11.1151 -0.000305176ZM0 12.3334C0 7.85724 2.84378 4.0249 6.87505 2.44256V4.91097C4.14624 6.3309 2.29175 9.11584 2.29175 12.3192C2.29175 16.9634 6.19042 20.7284 11 20.7284C15.8096 20.7284 19.7085 16.9634 19.7085 12.3192C19.7085 9.11592 17.854 6.33103 15.1253 4.91107V2.44262C19.1565 4.02499 22 7.8573 22 12.3334C22 18.2244 17.0753 23 11 23C4.92495 23 0 18.2244 0 12.3334Z"
      />
    </svg>
  );
};

export default Logout;
